"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AccountsList_module_css_1 = __importDefault(require("./AccountsList.module.css"));
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var theme = __assign(__assign({}, RAStyles_1.RaDatagridTheme), { sidebar: {
        width: 0,
        closedWidth: 0, // The default value is 55
    } });
var RaDataGridSx = {
    "& .RaDatagrid-table": {
        marginTop: "0px"
    },
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--secondary-color-tinted)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "100px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "150px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: "190px",
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    }
};
var SwitchAccountField = function () {
    var page = (0, useTypedPage_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return;
    var switchAccount = function () {
        ApiManager_1.default.switchCurrentAccount(page.props.user.id, record).then(function () {
            window.location.replace("/dashboard");
        });
    };
    return (react_1.default.createElement(react_admin_1.WrapperField, { sortable: false },
        react_1.default.createElement("div", { onClick: switchAccount, className: "d-flex align-items-center" },
            react_1.default.createElement(q_play_components_1.Button, { text: t("Sign into account"), isBold: false }))));
};
var AccountsList = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", { style: { width: "640px" } },
        react_1.default.createElement("h1", { className: "ns-font-family-bold " + AccountsList_module_css_1.default.headerText }, t("Accounts listing")),
        react_1.default.createElement("h6", { className: AccountsList_module_css_1.default.headerText }, t("Shows accounts assigned to partner")),
        react_1.default.createElement(react_admin_1.Admin, { theme: theme, dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "partner_accounts", list: react_1.default.createElement(react_admin_1.ListBase, { sort: { field: "is_reseller", order: "DESC" } },
                    react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RaDataGridSx, bulkActionButtons: false },
                        react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), sx: { fontFamily: "Geomanist-bold" }, sortable: false }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "id", label: t("ID"), sortable: false }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "players_count", label: t("Players count"), sortable: false }),
                        react_1.default.createElement(SwitchAccountField, null)),
                    react_1.default.createElement(Pagination_1.default, null)) }))));
};
exports.default = AccountsList;
